import React from 'react'

import { OrdersContext } from 'contexts/OrdersContext'
import {
  PixelButton,
  PixelCheckboxGroup,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/ajax'
import { put } from 'utils/api-routes.util'
import { WarehousePickup } from '../../../../../../decl.d'
interface IProps {
  courierId: string | number | null
  pickupAddress: WarehousePickup
  handleClose: (data: WarehousePickup) => void
}
const MapWarehouse = (props: IProps) => {
  const { state } = React.useContext(OrdersContext)
  const { courierId, pickupAddress, handleClose } = props

  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [data, setData] = React.useState({
    source_pickup_id: pickupAddress?.source_pickup_id,
    warehouse_id: '',
    courier_id: courierId,
  })
  React.useEffect(() => {
    setData({
      ...data,
      source_pickup_id: pickupAddress?.source_pickup_id,
      warehouse_id: '',
      courier_id: courierId,
    })
  }, [pickupAddress])
  const handleSubmit = (e) => {
    e.preventDefault()
    showPageLoader()
    put('/courier/pickup-address/warehouse-mapping', data).subscribe(
      (res: AjaxResponse<IResponse | any>) => {
        hidePageLoader()
        const responseData = res.response
        if (responseData.data) {
          showSuccess(responseData.message)
          handleClose(responseData.data)
        } else if (responseData.error && responseData.field) {
          showFailure(responseData.error)
        } else {
          showFailure(responseData.error)
        }
      },
    )
  }
  return (
    <form
      onSubmit={handleSubmit}
      style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
    >
      <PixelFlexBox
        flexWrap="wrap"
        gap="10px"
        width="100%"
        style={{ flexGrow: '1' }}
        flexDirection="row"
      >
        <PixelFlexBox padding="10px">
          <strong style={{ width: '30%' }}>Courier Pickup Address:</strong>
          <PixelText>{pickupAddress.address}</PixelText>
        </PixelFlexBox>
        <PixelCheckboxGroup
          direction="column"
          options={[...state.warehouses].map((item) => ({
            label: `${item.address}-(${item.name}-${item.wh_id})`,
            value: item.wh_id,
            type: 'radio',
            checked: item.wh_id == data.warehouse_id,
          }))}
          onChange={(e) => {
            setData({
              ...data,
              warehouse_id: e.target.value,
            })
          }}
        />
      </PixelFlexBox>
      <PixelFlexBox
        flexWrap="wrap"
        justifyContent="flex-end"
        gap="10px"
        width="100%"
        flexDirection="row"
      >
        <PixelButton variant="outline" onClick={handleClose}>
          Close
        </PixelButton>
        <PixelButton type="submit">Map</PixelButton>
      </PixelFlexBox>
    </form>
  )
}

export default MapWarehouse
